import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Alertify from "alertify.js";

export default class MessageRemover extends Component {

  configure() {
    return super.configure();
  }

  initialize() {
    $('.message:visible:not(.is-sticked)').addClass('is-deleted');
    return super.initialize();
  }
}